import { Hint } from '@lokalise/louis';

import Warning from './styles';

interface UnassignedKeysWarningProps {
    unassignedKeys: number;
    fallbackFileName: string;
}

const UnassignedKeysWarning = ({ unassignedKeys, fallbackFileName }: UnassignedKeysWarningProps) => (
    <Warning>
        {unassignedKeys} unassigned keys will be exported to {fallbackFileName}{' '}
        <Hint>
            Keys that are not assigned to filenames get exported to the default file (depends on platform). You can
            assign keys to filenames in the editor in bulk by selecting and mass-assigning.
        </Hint>
    </Warning>
);

export default UnassignedKeysWarning;
